import { useConfig } from "../../../../data/useConfig";
import {
  ListItemImage,
  ListItemPrice,
  ListItemTitle,
  SuggestionContainer,
  SuggestionListItem,
} from "../styles";

const ListTemplate = ({ onSuggestionClick, suggestedTerms }) => {
  const { autocompleteConfigs } = useConfig();
  const showPrices = autocompleteConfigs?.showPrices ?? true;

  return (
    <SuggestionContainer role="listbox">
      {suggestedTerms.map(({ label, value, params }) => (
        <SuggestionListItem
          className="bn-search__suggestion-list-item"
          onClick={() => onSuggestionClick({ label, params, value })}
          data-product-id={`${params.product_id}`}
          data-product-sku={`${params.sku}`}
        >
          <ListItemImage
            className="bn-search__suggestion-list-image"
            alt={label}
            src={params?.images?.[0]}
          />

          <ListItemTitle className="bn-search__suggestion-list-title">
            {label}
          </ListItemTitle>

          {showPrices && (
            <ListItemPrice className="bn-search__suggestion-list-price">
              R$ {params?.price_to?.toFixed(2).toString().replace(".", ",")}
            </ListItemPrice>
          )}
        </SuggestionListItem>
      ))}
    </SuggestionContainer>
  );
};

export default ListTemplate;
